import React from "react";
import styles from "./periodLineTab.module.css";

const PeriodLineTab = ({ selectedLine, horizontalLineHandler, children, values }) => {
  return (
    <div className={styles.periodContainer}>
      <div className={styles.mainLineContainer}>
        {values.map((line, index) => {
          const isSelected = selectedLine === line;

          return (
            <div key={index} className={styles.lineContainer} onClick={() => horizontalLineHandler(line)}>
              <div className={`${styles.periodTitleText} ${isSelected ? styles.periodSelectedText : ''}`}>
                {line}
              </div>
            </div>
          );
        })}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default PeriodLineTab;
